import React, { useEffect, useRef, useState } from "react";
import "./CreateVoteCard.scss";
import xlogo from "../../../assets/icons/x.svg";
import HeaderElement from "../../HeaderElement/HeaderElement";
import strings from "../../../locales/ro.json";
import PillButton from "../../Buttons/PillButton/PillButton";
import { Margin } from "@mui/icons-material";
import SendVote from "../../Buttons/SendVote/SendVote";
import Dropdown from "./dropdown";
import requestHandler from "../../../utils/requestHandler";
import { UserAuth } from "../../../context/AuthContext";
import StandardPopup from "../../Global/StandardPopup/StandardPopup";
import popupicon from "../../../assets/icons/createVotPopup.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

/**

### Props
- handleOptions(required): function from parent called whenever question/optionArray changes
- options(required): object containing the ballot data
- className(optional): classes that apply to the wrapper div of the object
- style(optional): styles that apply to the wrapper div of the object
### Example
```jsx
const [options, setOptions] = useState({});
// ... 
<CreateVoteCard options={options} handleOptions={setOptions}/>
```

### Balot Schema
```json
{
    "title": "string",
    "question": "string",
    "options": ["string"],
    "isSecret": "boolean",
    "isMultipleChoice": "boolean",
    "voteType": "type in ['Majority + 1','2/3', 'Poll', 'Non']"
}
```

### Responsibilities
- options: Both (Parent sets template, Child sets fields);
*/

const CreateVoteCard = ({ className, style, options, handleOptions }) => {
  
  //text init
  const questionRef = useRef(null);
  const { user } = UserAuth();
  const myAuthToken =
    `Bearer ${user.accessToken}`;
  const {abstainText, questionPlaceholderText, addOptionText, removeOptionText} = strings.createVote;
  const inputRefs = useRef([]);
  const optionArray = options?.options ? options.options : [];
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupFunction, setPopupFunction] = useState(() => {});
  const [fillerState, setFillerState] = React.useState("")

  const [groupArray, setGroupArray] = useState([]);
  const setOptionArray = (value) => {
    handleOptions({...options, options: [...value]});
  };
  const navigate = useNavigate();
  // update refs when array is updated
  useEffect(() => {
    optionArray.map((item, i) => {
      inputRefs.current[i].value = item;
      return "";
    });
  }, [optionArray]);

  useEffect(() => {
    requestHandler("groups","GET",myAuthToken)
    .then((result) => {

      setGroupArray([...result?.map((item) => {
        return {value: item.id, label: item.name}
      })
      ]);
    });
  }, []);

  const addOptionOnLoseFocus = (event) => {
    if (event.target.value === "") return;
    let initialOptionValue = event.target.value;
    let finalOptionValue =
      initialOptionValue.charAt(0).toUpperCase() + initialOptionValue.slice(1);
    let newArray = [];
    newArray = [...optionArray, finalOptionValue];
    event.target.value = "";
    setOptionArray(newArray);
  };
  const editOptionOnLoseFocus = (event, index) => {
    let newOptions = optionArray;
    newOptions = [...newOptions];

    if (event.target.value) newOptions[index] = event.target.value;
    else newOptions.splice(index, 1); // If blank we just remove
    setOptionArray(newOptions);
  };

  const handleOptionKeyDown = (event, index) => {
    if (event.keyCode === 13) {
      // Press enter
      if (index === -1) {
        // When adding new element

        if (event.target.value === "") return;
        let initialOptionValue = event.target.value;
        let finalOptionValue =
          initialOptionValue.charAt(0).toUpperCase() +
          initialOptionValue.slice(1);
        setOptionArray([...optionArray, finalOptionValue]);
      } // When we have to edit an actual item
      else {
        let newOptions = optionArray;
        newOptions = [...newOptions];
  
        if (event.target.value)
          newOptions[index] = event.target.value;
        else newOptions.splice(index, 1); // If blank we just remove
        setOptionArray(newOptions);
      }
      event.target.value = "";
    }
  };
  const element = document.querySelector('.pushedButton');

  const sanityCheck = () => {
    if (!options) return false;
    if (!options.question) return false;
    if (!options.options) return false;
    if (options.options.length === 0) return false;
    if (!options.voteType) return false;
    if (options.isMultipleChoice === undefined) return false;
    if (options.isSecret === undefined) return false;
    if (!options.title) return false;
    if (options.question.includes("$$$")) return false;
    if (options.title.includes("$$$")) return false;
    if (options.group === undefined) return false;
    return true;
  }
  // Sa ma pis pe functia asta ^

  return (
    <div className={`voteFormBG ${className}`} style={style}>
      <StandardPopup message={strings.createVote.createvotePopup} icon={popupicon} yesFcn={popupFunction} noFcn={() => {setPopupOpen(false)}} isOpen={popupOpen}/>
      <HeaderElement 
        placeholder={questionPlaceholderText}
        headerText={options?.title ? options.title : ""}
        inputHandler={handleOptions}
      />
      <PillButton
        className="marginTop" 
        options={strings.createVote.voteSecrecyTypes}
        handleInput={(value) => {handleOptions({...options, isSecret: value})}}
        chosen={options.isSecret}
      />
      <PillButton 
        className="marginTop" 
        options={strings.createVote.choiceTypes}
        handleInput={(value) => {handleOptions({...options, isMultipleChoice: value})}}
        chosen={options.isMultipleChoice}
      />
      <PillButton 
        className="marginTop" 
        options={strings.createVote.voteTypes}
        handleInput={(value) => {handleOptions({...options, voteType: value})}}
        chosen={options.voteType}
      />
      <Dropdown isInitialGAV = {options.group === 'GAV'} options={[
        { value: 'GAV', label: 'Vot de Adunare Generala' },
        ...groupArray
      ]} onSelect={(value) => {handleOptions({...options, group: value})}}/>
      <input
        type="text"
        ref={questionRef}
        placeholder={questionPlaceholderText}
        defaultValue={options.question}
        className="questionInput"
        onChange={(event) => 
          handleOptions({...options, question: event.target.value})
        }
        onFocus={() => {
          const patternIndex = options.question ? options.question.indexOf("$$$") : -1;

          // Check if the pattern exists
          if (patternIndex !== -1) {
            // Set the selection range to the first occurrence of $$$
            questionRef.current.setSelectionRange(patternIndex, patternIndex + 3);
          }
        }}
      >

      </input>
      <div>

      <div className="voteOptions">
        {optionArray.map((item, i) => {
          return (
            <div key={i}>
              <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
              <input
                type="text"
                className="optionInput"
                placeholder={removeOptionText}
                onKeyDown={(event) => {
                  handleOptionKeyDown(event, i);
                }}
                onBlur={(event) => {
                  editOptionOnLoseFocus(event, i);
                }}
                ref={(el) => (inputRefs.current[i] = el)} // Obtain ref array
              />
              <img
                src={xlogo}
                alt="close"
                onClick={() => {
                  handleOptionKeyDown(
                    { keyCode: 13, target: { value: "" } },
                    i
                  ); // Hardcoding an "enter" key press event
                  // with empty value target => deleting element
                }}
              />
            </div>
          );
        })}
        <div className="optionInput1">
          <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
          <input
            type="text"
            className="optionInput"
            placeholder={addOptionText}
            onKeyDown={(event) => {
              handleOptionKeyDown(event, -1);
            }}
            onBlur={(event) => {
              addOptionOnLoseFocus(event);
            }}
          />
        </div>
        {!(options.group === 'GAV')? null : (<div className="voteOption">
          <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
          <input
            type="text"
            className="optionInput disabled"
            defaultValue={abstainText}
          />
        </div>)}
      </div>

      <div className="CreateVoteSendButton">
        <SendVote enabled={sanityCheck()} onClickFunction={
          () => {
            if (!sanityCheck()) return;

            let finalOptions = [...options.options];

            if(options.group === 'GAV')
              finalOptions.push(abstainText)
            let body = {
              uid: 1,
              title: options.title,
              question: {
                  text: options.question,
                  options: finalOptions,
                  isMultipleChoice: options.isMultipleChoice,
                  voteCountingRule: options.voteType
              },
              voteGroupID: options.group === 'GAV' ? 0 : options.group,
              viewGroupID: options.group === 'GAV' ? 0 : options.group,
              isGeneralAssemblySplitVote: options.group === 'GAV',
              showVotesPublicly: !options.isSecret
            };
            setPopupFunction((prevFcn) => {
              return () => {
                setPopupOpen(false);
                requestHandler("ballots","PUT",myAuthToken,body).then(() => {
                  navigate("/")
                })
              };
            });
            setPopupOpen(true);

          }}
        />
      </div>
      </div>
    </div>
  );
};

export default CreateVoteCard;
